import AppDialog from '../../../components/app_dialog'
import { TextArea } from '@cinesend/ui-kit'
import useStore from '../../../hooks/use_store'
import { useQueryClient } from '@tanstack/react-query'

const ResolveIssueModal = ({ issue, onClose, queryKey }) => {
  const { deleteModel } = useStore()
  const queryClient = useQueryClient()
  const { uuid, description, deleted_at } = issue

  const resolveIssue = () => {
    deleteModel.mutate(
      {
        endpoint: `issues`,
        id: uuid,
        confirmMessage: `Are you sure you want to resolve this issue?`,
        confirmTitle: 'Resolve issue',
        confirmText: 'Resolve',
        confirmVariant: 'primary',
      },
      {
        onSuccess: (res) => queryClient.invalidateQueries([queryKey]),
        onError: (err) => console.log(err),
        onSettled: () => onClose(),
      }
    )
  }

  return (
    <AppDialog
      title='Resolve issue'
      onClose={() => onClose()}
      confirmText='Resolve'
      onConfirm={deleted_at ? undefined : () => resolveIssue()}
    >
      <div className='min-w-96'>
        <TextArea label='Description' hideLabel value={description} disabled />
      </div>
    </AppDialog>
  )
}

export default ResolveIssueModal
